import React from 'react';
import ServicePageShell from '../../components/ServicePageShell';
import MechinotStatic from './MechinotStatic';

export default function Mechinot() {
  return (
    <ServicePageShell
      strapiApiId="annexe-mechinot"
      defaultSectionLabel="Annexes"
      defaultTitle="Mechinot"
      StaticFallback={MechinotStatic}
    />
  );
}
